import type { UseQueryOptions, UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import type { GetLessonsResponse } from "api/services/content/schemas/lessons";
import { useApiClient } from "api/useApiClient";

const queryKeyPrefix = "getLessons";
type QueryKey = [typeof queryKeyPrefix, GetLessonsParams];
const getLessonsQueryKey = (params: GetLessonsParams): QueryKey => [queryKeyPrefix, params];

export interface GetLessonsParams {
  joint?: string;
  limit?: number;
  locale?: string;
  page?: number;
  search?: string;
}

export const useGetLessons = (
  params: GetLessonsParams = {},
  options?: UseQueryOptions<GetLessonsResponse, Error, GetLessonsResponse, QueryKey>
): UseQueryResult<GetLessonsResponse, Error> => {
  const client = useApiClient();
  return useQuery(
    getLessonsQueryKey(params),
    () => {
      return client.getLessons(params);
    },
    options
  );
};
